import { useSelector } from "react-redux";
import DataInputPanel from "./DataInputPanel";
import { useGetQuestionsOfRound } from "hooks/query/issb/issb";
import { useSearchParams } from "react-router-dom";

/**
 * Wrapper on DataInputPanel
 */
const DataInputPage = () => {
  const roundSelector = useSelector((state) => state.issbRound);
  const roundId = roundSelector?.selectedRound?.id;

  const { data: fullQuestionList } = useGetQuestionsOfRound(null, roundId, {
    enabled: !!roundId,
  });
  return <DataInputPanel fullQuestionList={fullQuestionList} />;
};

export default DataInputPage;
